import React, { useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { ResourceContent } from './ResourceContent';
import { FroalaEditorsSettings } from 'src/config/configs';
import { useStudentSelector } from '../../store/selectors/useStudentSelector';

export const ResourceWrapper: React.FC<{ froalaEditorsSettings: FroalaEditorsSettings }> = React.memo(({ froalaEditorsSettings }) => {
  const currentResourceId = useStudentSelector((state) => state.currentResource);
  const ref = useRef(null);

  return (
    <TransitionGroup>
      {currentResourceId ? (
        <CSSTransition nodeRef={ref} classNames="fade" timeout={450} in={true} appear={true} unmountOnExit={true}>
          <div ref={ref}>
            <ResourceContent key={currentResourceId} resourceId={currentResourceId} froalaEditorsSettings={froalaEditorsSettings} />
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
});
